export default __webpack_public_path__ + "static/media/ic-art-Heart-Dumbell.0db78179.svg";